/* import __COLOCATED_TEMPLATE__ from './project-details-files-legal-item.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { APPLICATION } from 'sh-www/models/application';
import { showModal } from 'sh-www/utils/modal-controls';
import { absoluteStoryhunterUrl } from 'sh-www/utils/url';

const APPLICATION_STATUSES_WHERE_LEGAL_CAN_CHANGE = [
  APPLICATION.STATUS.PUBLISHER_APPROVED,
  APPLICATION.STATUS.PENDING,
];

class ProjectDetailsFilesLegalItem extends Component {
  @service moment;
  @service session;

  get legalStatusText() {
    const { accepted, acceptedAt } = this.args.legalAgreement;

    const person = this.session.currentUser.isBuyer
      ? this.args.application.seller.fullName
      : 'you';

    const date = this.moment.moment(acceptedAt).format('MM/DD/YYYY');

    return accepted
        ? `Signed by ${person} • ${date}`
        : `Pending agreement from ${person}`;
  }

  get legalMenuDropdownOptions() {
    const menuOptions = [];

    menuOptions.push({
      title: 'Download as PDF',
      onClick: () => this.onDownloadPDFClicked(),
    });

    if (this.canChangeLegal) {
      menuOptions.push({
        title: 'Change',
        onClick: () => this.onChangeLegalClicked(),
      });
    }

    return menuOptions;
  }

  get canChangeLegal() {
    if (!APPLICATION_STATUSES_WHERE_LEGAL_CAN_CHANGE.includes(this.args.application.status) || !this.session.currentUser.isBuyer) {
      return false;
    }

    const legals = this.args.application.company.legals;
    const currentLegalID = this.args.legalAgreement.legal.id;
    const alternativeLegals = legals.filter((legal) => legal.id !== currentLegalID);

    return alternativeLegals.length > 0;
  }

  @action
  onChangeLegalClicked() {
    const modalModel = {
      application: this.args.application,
      onLegalChanged: () => {
        this.args.loadApplicationTask.perform(this.args.application.id, ['legal-agreements.legal']);
      }
    };
    showModal(this, 'projects/change-freelancer-agreement-modal', modalModel);
  }

  @action
  onDownloadPDFClicked() {
    window.open(absoluteStoryhunterUrl(`/applications/${this.args.application.id}/legal-agreements/${this.args.legalAgreement.id}/download`));
  }
}

export default ProjectDetailsFilesLegalItem;
